export enum HarvestTypes {
    Re_Weighment = 'Re Weighment',
    Live_Harvest = 'Live Harvest',
  }